module.exports = __webpack_public_path__ + "media/images/logo_header-561ba0897b791932ab57355b6e9eacc6.svg";